    jQuery(window).on('load', function() {
        if(window.location.href.includes('#')) {
            var id = window.location.href.split('#')[1]-1;
            var element = jQuery('.layout--yhteystieto_listaus .row').children().get(id);
            element.querySelector('.alue-toggle').click();
        }
        handleMaps();
    });

    jQuery(window).resize(function() {
        handleMaps();
    });

    function handleMaps() {

        if(jQuery(window).width() > 800 ) {
            jQuery('.map-embed iframe').each(function() {
                jQuery(this).attr('src', jQuery(this).attr('src').split('&z=')[0] + '&z=6');
            });
        } else if(jQuery(window).width() > 340) {
            jQuery('.map-embed iframe').each(function() {
                jQuery(this).attr('src', jQuery(this).attr('src').split('&z=')[0] + '&z=5');
            });
        } else {
            jQuery('.map-embed iframe').each(function() {
                jQuery(this).attr('src', jQuery(this).attr('src').split('&z=')[0] + '&z=4');
            });
        }
    }

    jQuery('.footer__palsta-linkit li a').click(function() {
        if(jQuery(this).attr('href').includes('#')) {
            var id =  jQuery(this).attr('href').split('#')[1]-1;
            var element = jQuery('.layout--yhteystieto_listaus .row').children().get(id);
            element.querySelector('.alue-toggle').click();
        };
    });
    
    jQuery('.alue-toggle').click(function() {
        jQuery(this).parent().parent().toggleClass('open');
        if(jQuery(this).parent().parent().hasClass('open')) {
            window.scrollTo({top: jQuery(this).offset().top - 70, behavior: "smooth"});
        }
    });